import ApiIntegrationPage from '@/modules/settings/pages/ApiIntegrationPage'
import OauthKeyScopesPage from '@/modules/settings/pages/OauthKeyScopesPage'
import ChannelSettingsPage from '@/modules/settings/pages/ChannelSettingsPage'
import DataRetentionPage from '@/modules/settings/pages/DataRetentionPage'
import DataRetentionOverviewTab from '@/modules/settings/components/DataRetentionOverviewTab'
import DataRetentionPoliciesTab from '@/modules/settings/components/DataRetentionPoliciesTab'
import DataRetentionHistoryTab from '@/modules/settings/components/DataRetentionHistoryTab'
import RetentionAuditLogTab from '@/modules/settings/components/RetentionAuditLogTab'
import EnableChannelsTab from '@/modules/settings/components/EnableChannelsTab'
import EngagementRulesTab from '@/modules/settings/components/EngagementRulesTab'
import UrlTrackingTab from '@/modules/settings/components/UrlTrackingTab'
import PushSettingsTab from '@/modules/settings/components/PushSettingsTab'
import GaSettingsPage from '@/modules/settings/pages/GaSettingsPage'
import SegmentationSettingsPage from '@/modules/settings/pages/SegmentationSettingsPage'
import StreamingSettingsPage from '@/modules/settings/pages/StreamingSettingsPage'
import WebFontSettingsPage from '@/modules/settings/pages/WebFontSettingsPage'
import CustomerIntelligencePage from '@/modules/settings/pages/CustomerIntelligencePage'
import EmailSettingsPage from '@/modules/settings/pages/EmailSettingsPage'
import SmsSettingsPage from '@/modules/settings/pages/SmsSettingsPage'
import InboxSettingsPage from '@/modules/settings/pages/InboxSettingsPage'
import DatabaseSourceSettingsPage from '@/modules/settings/pages/DatabaseSourceSettingsPage'
import LoyaltySettingsPage from '@/modules/settings/pages/LoyaltySettingsPage'
import OpenLiveActivitiesSettingsPage from '@/modules/settings/pages/OpenLiveActivitiesSettingsPage'
import SshKeyManagementPage from '@/modules/settings/pages/SshKeyManagementPage'
import InternalApiDocsPage from '@/modules/settings/pages/InternalApiDocsPage'

export default [
  {
    name: 'ApiIntegration',
    path: '/account/project/api-integration',
    component: ApiIntegrationPage,
    meta: {
      auth: ['manageProjectTechnical'],
      title: 'ApiIntegration_Title'
    }
  },
  {
    name: 'OauthKeyScopes',
    path: '/account/project/oauth-key-scopes',
    component: OauthKeyScopesPage,
    meta: {
      auth: ['manageProjectTechnical'],
      title: 'ApiIntegration_Scopes_PageTitle'
    }
  },
  {
    name: 'ChannelSettings',
    path: '/account/project/channels-settings',
    component: ChannelSettingsPage,
    meta: {
      auth: ['viewProjectTechnical', 'manageProjectTechnical'],
      title: 'ProjectSettings_ChannelSettings_Title'
    },
    children: [
      {
        name: 'EnableChannelsTab',
        path: 'enable-channels',
        component: EnableChannelsTab,
        project: true,
        meta: {
          auth: ['viewProjectTechnical', 'manageProjectTechnical']
        }
      },
      {
        name: 'EngagementRulesTab',
        path: 'engagement-rules-categories',
        component: EngagementRulesTab,
        project: true,
        meta: {
          auth: ['viewProjectTechnical', 'manageProjectTechnical']
        }
      },
      {
        name: 'UrlTrackingTab',
        path: 'link-tracking',
        component: UrlTrackingTab,
        project: true,
        meta: {
          auth: ['viewProjectTechnical', 'manageProjectTechnical']
        }
      },
      {
        name: 'PushSettingsTab',
        path: 'push-settings',
        component: PushSettingsTab,
        project: true,
        meta: {
          auth: ['viewProjectTechnical', 'manageProjectTechnical']
        }
      }
    ]
  },
  {
    name: 'InboxSettings',
    path: '/account/project/inbox-settings',
    component: InboxSettingsPage,
    meta: {
      auth: ['viewProjectTechnical', 'manageProjectTechnical'],
      title: 'ProjectSettings_ChannelSettings_Title'
    }
  },
  {
    name: 'SmsSettings',
    path: '/account/project/sms-settings',
    component: SmsSettingsPage,
    meta: {
      auth: ['viewProjectTechnical', 'manageProjectTechnical'],
      title: 'ProjectSettings_ChannelSettings_Title'
    }
  },
  {
    name: 'EmailSettings',
    path: '/account/project/email-settings',
    component: EmailSettingsPage,
    meta: {
      auth: ['viewProjectTechnical', 'manageProjectTechnical'],
      title: 'ProjectSettings_ChannelSettings_Title'
    }
  },
  {
    name: 'GoogleAnalyticsSettings',
    path: '/account/project/ga-settings',
    component: GaSettingsPage,
    meta: {
      auth: ['viewProjectTechnical', 'manageProjectTechnical'],
      title: 'GoogleAnalyticsSettings_Title'
    }
  },
  {
    name: 'DataRetention',
    path: '/account/project/data-retention',
    component: DataRetentionPage,
    meta: {
      auth: [
        'DataRetention:ReadAccess',
        'DataRetention:AuditAccess',
        'DataRetention:ManageAccess'
      ],
      title: 'DataRetention_Title'
    },
    children: [
      {
        name: 'DataRetentionOverview',
        path: 'overview',
        component: DataRetentionOverviewTab,
        meta: {
          auth: [
            'DataRetention:ReadAccess',
            'DataRetention:AuditAccess',
            'DataRetention:ManageAccess'
          ],
          title: 'DataRetention_Title'
        }
      },
      {
        name: 'DataRetentionPolicies',
        path: 'policies',
        component: DataRetentionPoliciesTab,
        meta: {
          auth: [
            'DataRetention:ReadAccess',
            'DataRetention:AuditAccess',
            'DataRetention:ManageAccess'
          ],
          title: 'DataRetention_Title'
        }
      },
      {
        name: 'DataRetentionAuditLog',
        path: 'audit-log',
        component: RetentionAuditLogTab,
        meta: {
          auth: ['DataRetention:AuditAccess', 'DataRetention:ManageAccess'],
          title: 'DataRetention_Title'
        }
      },
      {
        name: 'DataRetentionHistory',
        path: 'history',
        component: DataRetentionHistoryTab,
        meta: {
          auth: ['DataRetention:ReadAccess'],
          title: 'DataRetention_Title'
        }
      },
      {
        path: '',
        redirect: { name: 'DataRetentionPolicies' }
      }
    ]
  },
  {
    name: 'SegmentationSettings',
    path: '/account/project/segmentation-settings',
    component: SegmentationSettingsPage,
    meta: {
      auth: ['admin', 'admin-support', 'admin-viewer'],
      title: 'SegmentationSettings_Title'
    }
  },
  {
    name: 'StreamingSettings',
    path: '/account/project/streaming-settings',
    component: StreamingSettingsPage,
    meta: {
      auth: ['admin', 'admin-support', 'admin-viewer'],
      title: 'StreamingSettings_Title'
    }
  },
  {
    name: 'WebFontSettings',
    path: '/account/project/webfont-settings',
    component: WebFontSettingsPage,
    meta: {
      auth: ['WebFont:ReadAccess', 'WebFont:FullAccess'],
      title: 'WebFont_Title'
    }
  },
  {
    name: 'CustomerIntelligenceSettings',
    path: '/account/project/customer-intelligence-settings',
    component: CustomerIntelligencePage,
    meta: {
      auth: ['admin', 'admin-support', 'admin-viewer'],
      title: 'ProjectSettings_Customer_Intelligence'
    }
  },
  {
    name: 'DatabaseSourceSettings',
    path: '/account/project/database-source-settings',
    component: DatabaseSourceSettingsPage,
    meta: {
      auth: ['admin', 'admin-support', 'admin-viewer'],
      title: 'DatabaseSourceSettings_Title'
    }
  },
  {
    name: 'LoyaltySettings',
    path: '/account/project/loyalty-settings',
    component: LoyaltySettingsPage,
    meta: {
      auth: ['admin', 'admin-support', 'admin-viewer'],
      title: 'LoyaltySettings_Title'
    }
  },
  {
    name: 'OpenLiveActivitiesSettings',
    path: '/account/project/open-live-activity-settings',
    component: OpenLiveActivitiesSettingsPage,
    meta: {
      projectFeatures: {
        items: ['openLiveActivities'],
        notFound: true
      },
      auth: ['admin', 'admin-support', 'admin-viewer'],
      title: 'OpenLiveActivities_Title'
    }
  },
  {
    name: 'SshKeyManagement',
    path: '/account/project/ssh-keys',
    component: SshKeyManagementPage,
    meta: {
      auth: ['viewProjectTechnical', 'manageProjectTechnical'],
      title: 'SshKeyManagement_Title'
    }
  },
  {
    name: 'InternalApiDocs',
    path: '/account/project/internal-api-docs',
    component: InternalApiDocsPage,
    meta: {
      auth: ['admin', 'admin-support', 'admin-viewer'],
      title: 'InternalApiDocs_Title'
    }
  }
]



// WEBPACK FOOTER //
// ./src/modules/settings/router/index.js